<div class="container m-0">
  <div class="row picker-row">
    <div class="col-6 mb-1 no-col-padding">
      <input
        class="form-control form-control-sm datepicker-input"
        #datepickerFull="bsDatepicker"
        bsDatepicker
        [formControl]="date"
        [bsConfig]="{
          dateInputFormat: 'DD-MM-YYYY',
          containerClass: 'theme-dark-blue',
        }" />
    </div>
    <div class="picker col-6 mb-1 no-col-padding">
      <timepicker
        [formControl]="time"
        [showMeridian]="false"
        [mousewheel]="false"></timepicker>
    </div>
  </div>
</div>
